<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { i18n } from "@/js/i18nController";

// Композабл для реактивной локализации
const { t } = useI18n();

// Создаем вычисляемое свойство для текущей локали
const currentLocale = computed(() => i18n.global.locale.value);

// Реф для wheel__bottom элемента
const wheelBottomRef = ref(null);

// Реактивные переменные для размеров окна
const windowWidth = ref(window.innerWidth);
const windowHeight = ref(window.innerHeight);

// Начальные значения для углов и шага
const initialAngle = 67.5;
const step = 45;

// Реактивная переменная для хранения значения offset
const offset = ref(calculateOffset());

// Функция для вычисления offset на основе ширины экрана
function calculateOffset() {
  const width = windowWidth.value;
  const height = windowHeight.value;

  // Приоритетная проверка для горизонтального мобильного (самое специфичное условие)
  if (width > height && width <= 1110 && height <= 490) {
    return -88;
  }

  // Остальные условия по возрастанию ширины экрана
  if (width < 430) {
    return -85;
  } else if (width >= 430 && width < 896) {
    return -110;
  } else if (width >= 896 && width < 1020) {
    return -104;
  } else if (width >= 1020 && width < 1366) {
    return -98;
  } else if (width >= 1366 && width < 1920) {
    return -128;
  } else {
    // 1920px и больше
    return -178;
  }
}

// Функция для обновления CSS переменной offset
function updateOffset() {
  windowWidth.value = window.innerWidth;
  windowHeight.value = window.innerHeight;
  offset.value = calculateOffset();
}

onMounted(() => {
  // Обновление при инициализации
  updateOffset();

  // Добавление слушателя resize и orientationchange
  window.addEventListener("resize", updateOffset);
  window.addEventListener("orientationchange", updateOffset);
});

onUnmounted(() => {
  // Удаление слушателя resize и orientationchange при размонтировании компонента
  window.removeEventListener("resize", updateOffset);
  window.removeEventListener("orientationchange", updateOffset);
});

// Функция для вычисления стилей сектора
const getSectorStyle = (index) => {
  return {
    transform: `rotate(${initialAngle + step * index}deg) translateX(${offset.value}px)`,
  };
};

setTimeout(() => {
  updateOffset();
}, 500);
</script>

<template>
  <div class="wheel">
    <div class="wheel__shadow"></div>
    <div class="wheel__bottom"></div>
    <div class="wheel__sectors">
      <div
        v-for="i in 8"
        :key="i"
        :class="`sector sector-${i} sector-${i}-${currentLocale}`"
        :style="getSectorStyle(i - 1)"
        dir="ltr"
      >
        {{ t(`wheel_text.sector_${i}`) }}
      </div>
    </div>
    <div class="wheel__ring"></div>
    <div class="wheel__button spin" :class="currentLocale">
      {{ t("wheel_button") }}
    </div>
  </div>
</template>

<style lang="scss">
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";

@import "./Wheel.scss";
</style>
